import { useEffect, useState } from 'react';

const CChatbot = () => {
  const [iframeVisible, setIframeVisible] = useState(false);
  const [isMaximized, setIsMaximized] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 500);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);

    const handleMessage = (event: MessageEvent) => {
      if (event.data === 'openChatbot') {
        setIframeVisible(true);
      } else if (event.data === 'closeChatbot') {
        setIframeVisible(false);
      } else if (event.data === 'maximizeChatbot') {
        setIsMaximized(true);
      } else if (event.data === 'minimizeChatbot') {
        setIsMaximized(false);
      }
    };

    window.addEventListener('message', handleMessage);

    const style = document.createElement("style");
    style.id = "tzzai-hide-flash";
    style.textContent = `
      iframe[src*="toolzz.ai"],
      iframe[src*="chat-embed"] {
        color-scheme: light !important;
      }
    `;
    document.head.appendChild(style);

    return () => {
      window.removeEventListener('message', handleMessage);
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  const getWidth = () => {
    if (!iframeVisible) return isMobile ? '70px' : '100px';
    if (isMobile) return '100vw';
    return isMaximized ? '500px' : '420px';
  };

  const getHeight = () => {
    if (!iframeVisible) return isMobile ? '70px' : '100px';
    if (isMobile) return '100vh';
    return '800px';
  };

  const getPosition = () => {
    if (iframeVisible && isMobile) {
      return { bottom: '0', right: '0', top: '0', left: '0' };
    }
    return { bottom: isMobile ? '10px' : '15px', right: isMobile ? '10px' : '15px' };
  };

  const position = getPosition();

  return (
    <iframe src='https://admin.toolzz.ai/embed/a4400bda-74e8-43d5-874a-4b19302d3341'
      title='Chatbot'
      style={{
        width: getWidth(),
        height: getHeight(),
        position: 'fixed',
        bottom: position.bottom,
        right: position.right,
        top: position.top || 'auto',
        left: position.left || 'auto',
        border: 'none',
        zIndex: 2147483647,
        background: 'transparent',
        maxWidth: '100vw',
        maxHeight: '100vh'
      }}
      allowTransparency={true}
      allow="microphone"
    >
    </iframe>
  );
};

export default CChatbot;
